import React from 'react';
import { render } from 'react-dom';
import { LocationVisualizer } from './LocationVisualizer';

const id = document.currentScript.getAttribute('data-map-div-id') || 'location-visualizer';
const site = JSON.parse(document.currentScript.dataset.site || null);
const sites = JSON.parse(document.currentScript.dataset.sites || null) || [];
const options = JSON.parse(document.currentScript.dataset.options || null) || {};
const node = document.getElementById(id);
render(
    <LocationVisualizer
        site={site}
        sites={sites}
        options={options}
        filterVisited
    />,
    node
);
